import { collection, doc, getDoc, updateDoc } from "firebase/firestore";
import { db } from "shared/api/firebase";
import { PageModuleData, PageModuleStatus } from "../types";

type Params = {
  moduleId: string;
  status: PageModuleStatus;
  brandId: string;
  pageId: string;
};

type ModuleStatusUpdate = {
  status: PageModuleStatus;
  updatedAt: Date;
  scheduledStartAt?: string;
  scheduledEndAt?: string;
};

export const updatePageModuleStatus = async ({
  brandId,
  pageId,
  moduleId,
  status,
}: Params): Promise<PageModuleData> => {
  try {
    const collectionRef = collection(
      db,
      `brands/${brandId}/pages/${pageId}/modules`,
    );
    const moduleDocRef = doc(collectionRef, moduleId);

    const moduleTemplateSnapshot = await getDoc(moduleDocRef);

    if (!moduleTemplateSnapshot.exists()) {
      throw new Error(`Module with ID ${moduleId} not found`);
    }

    const moduleTemplate = moduleTemplateSnapshot.data() as PageModuleData;

    const updateData: ModuleStatusUpdate = {
      status,
      updatedAt: new Date(),
    };

    // Clear scheduling data if module status is being changed from Expired to Active or Draft
    if (
      moduleTemplate.status === PageModuleStatus.Expired &&
      (status === PageModuleStatus.Active || status === PageModuleStatus.Draft)
    ) {
      updateData.scheduledStartAt = "";
      updateData.scheduledEndAt = "";
    }

    await updateDoc(moduleDocRef, updateData);

    const updatedModuleSnapshot = await getDoc(moduleDocRef);

    if (!updatedModuleSnapshot.exists()) {
      throw new Error(`Failed to fetch updated module with ID ${moduleId}`);
    }

    return updatedModuleSnapshot.data() as PageModuleData;
  } catch (error) {
    console.error(`Error updating module status: ${(error as Error).message}`);
    throw error;
  }
};
